import { FC, PropsWithChildren } from "react";

import { ReportsContext, useReportsCtxProvider } from "@ryde/redux";

export const ReportsContextWrapper: FC<PropsWithChildren> = ({ children }) => {
  const hookData = useReportsCtxProvider();

  return (
    <ReportsContext.Provider value={hookData}>
      {children}
    </ReportsContext.Provider>
  );
};
